import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * GTM SPA page-view tracker.
 *
 * The base GTM snippet in public/index.html fires only on initial page load.
 * This component pushes a virtual `page_view` event to window.dataLayer on
 * every React Router navigation so all subsequent routes are tracked correctly
 * by whatever tags (GA4, Yandex.Metrika, Ads, etc.) are configured inside GTM.
 *
 * Mount once at the top of the app, inside the <Router>. Renders nothing.
 */
export default function GTMTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const path = location.pathname + location.search + location.hash;
    const url = window.location.origin + path;
    const title = typeof document !== "undefined" ? document.title : undefined;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "page_view",
        page_location: url,
        page_path: path,
        page_title: title,
      });
    } catch {
      // Never let analytics break the app
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}
